import { Injectable } from '@angular/core';
import {Http, Response, Headers} from "@angular/http";
import "rxjs/add/operator/map";
import {Observable} from "rxjs/Observable";


import { Consorcio } from '../model/Consorcio';
import { CatalogoCobro } from '../model/catalogo-cobro';

import { UtilitiesService } from '../services/utilities.service'

import 'rxjs/add/operator/catch';
@Injectable()
export class CatalogoCobroService {

  constructor(
  private _http:Http,
  private _utilities:UtilitiesService
  ){ }



getCobros(consorcio: Consorcio) : Observable<CatalogoCobro[]> {
         
    let json = {   "Metodo": "findCatalogoCobro",   "Datos":  consorcio};

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("get"), 
				params, {headers: headers}).map(res => res.json());       
 
  }

  public insert(catalogo: CatalogoCobro){
   
    let json = {   "Metodo": "postCatalogoCobro",   "Datos": catalogo  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());
}

public delete(cobro: CatalogoCobro){
   
    let json = {   "Metodo": "deleteCatalogoCobro",   "Datos": cobro  };

    let params = "Data="+ this._utilities.getEscapeString(JSON.stringify(json));
		let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});

		return this._http.post(this._utilities.getURL("post"), 
				params, {headers: headers}).map(res => res.json());


}

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/services/catalogo-cobro.service.ts